var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v(_vm._s(_vm.title))])], 1)], 1)])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2 justify-content-between"
  }, [_c('div', {
    staticClass: "col-12 col-xl-8 mb-2 mb-xl-0 d-flex justify-content-between"
  }, [_c('h4', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.title))]), !_vm.isEdit && _vm.$permissions.has(_vm.$permissions.consts.MY_CHANGE_PROFILE) ? _c('b-button', {
    attrs: {
      "variant": "inverse-warning",
      "to": {
        name: 'Profile',
        query: {
          'mode': 'edit'
        }
      }
    }
  }, [_vm._v("編輯基本資料 ")]) : _vm._e()], 1), _c('div', {
    staticClass: "col-12 col-xl-8 mt-3"
  }, [_vm.validationErrors ? _c('validation-error-alert', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": _vm.displayText('staff.staff_belong_branch', '所屬分店')
    }
  }, _vm._l(_vm.branches, function (branch) {
    return _c('div', {
      key: branch.id,
      staticClass: "mb-2 d-flex"
    }, [_c('b-input-group', {
      staticClass: "col-7 pl-0"
    }, [_c('b-form-select', {
      staticClass: "form-control",
      attrs: {
        "disabled": ""
      },
      model: {
        value: branch.id,
        callback: function callback($$v) {
          _vm.$set(branch, "id", $$v);
        },
        expression: "branch.id"
      }
    }, [_c('b-form-select-option', {
      attrs: {
        "value": null,
        "disabled": ""
      }
    }, [_vm._v(" " + _vm._s(_vm.displayText('staff.branch_select', '請選擇分店')) + " ")]), _vm._l(_vm.branchOptions, function (branchOption, index) {
      return _c('b-form-select-option', {
        key: index,
        attrs: {
          "value": branchOption.id
        }
      }, [_vm._v(_vm._s(_vm.displayBranchName(branchOption)) + " ")]);
    })], 2)], 1), _c('b-form-group', {
      staticClass: "mb-0",
      attrs: {
        "label-cols": "4",
        "label-size": "sm",
        "label": _vm.displayText('staff.branch_sort', '店內順序')
      }
    }, [_c('b-form-input', {
      staticClass: "mb-2 mr-sm-2 mb-sm-0",
      attrs: {
        "type": "number",
        "min": "1",
        "disabled": ""
      },
      on: {
        "change": _vm.orderChanged
      },
      model: {
        value: branch.order,
        callback: function callback($$v) {
          _vm.$set(branch, "order", $$v);
        },
        expression: "branch.order"
      }
    })], 1)], 1);
  }), 0), _vm.hiddenField('employee_code') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": '*' + _vm.displayTextStaff('staff_code', '員工編號')
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "value": _vm.staff.employee_code,
      "readonly": true
    }
  })], 1) : _vm._e(), _vm.hiddenField('name') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label-for": "input-1",
      "label": _vm.displayRequireSign('name') + _vm.displayTextStaff('staff_name', '* 姓名')
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "input-1",
      "type": "text",
      "state": _vm.v$.staff.name.$error ? false : null,
      "readonly": !_vm.isEdit
    },
    model: {
      value: _vm.staff.name,
      callback: function callback($$v) {
        _vm.$set(_vm.staff, "name", $$v);
      },
      expression: "staff.name"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.staff.name.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1) : _vm._e(), _vm.$permissions.has(_vm.$permissions.consts.SALES_BIND_URI) ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "聊天室綁定連結"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    model: {
      value: _vm.chatBindUrl,
      callback: function callback($$v) {
        _vm.chatBindUrl = $$v;
      },
      expression: "chatBindUrl"
    }
  })], 1) : _vm._e(), _vm.$permissions.has(_vm.$permissions.consts.SALES_SPECIFIC_URI) ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "業務綁定連結",
      "label-for": "input-1"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "input-1",
      "type": "text",
      "readonly": ""
    },
    model: {
      value: _vm.salesBindUrl,
      callback: function callback($$v) {
        _vm.salesBindUrl = $$v;
      },
      expression: "salesBindUrl"
    }
  })], 1) : _vm._e(), _vm.$permissions.has(_vm.$permissions.consts.MY_BIND_URI) ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "綁定網址",
      "label-for": "input-1"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "input-1",
      "type": "text",
      "readonly": ""
    },
    model: {
      value: _vm.myBindUrl,
      callback: function callback($$v) {
        _vm.myBindUrl = $$v;
      },
      expression: "myBindUrl"
    }
  })], 1) : _vm._e(), _vm.hiddenField('avatar') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": _vm.displayRequireSign('avatar') + _vm.displayTextStaff('staff_avatar', '個人頭像'),
      "label-for": "input-1"
    }
  }, [_vm.image || _vm.staff.avatar_url ? _c('li', {
    staticClass: "s-image-list-item s-draggable"
  }, [_c('img', {
    staticClass: "s-cropped-image",
    attrs: {
      "src": _vm.image || _vm.staff.avatar_url
    }
  }), _vm.isEdit ? _c('button', {
    staticClass: "btn btn-danger s-delete-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.deleteImage();
      }
    }
  }, [_vm._v("Ｘ")]) : _vm._e()]) : _c('li', {
    staticClass: "s-image-list-item"
  }, [_vm.isEdit ? _c('ImageSelector', {
    on: {
      "input": _vm.selectImage
    },
    scopedSlots: _vm._u([{
      key: "trigger",
      fn: function fn(_ref) {
        var openFileSelector = _ref.openFileSelector;
        return [_c('button', {
          staticClass: "btn s-trigger-btn",
          on: {
            "click": openFileSelector
          }
        }, [_vm._v("＋ 加入照片")])];
      }
    }], null, false, 2253959016)
  }) : _vm._e()], 1)]) : _vm._e(), _vm.hiddenField('email') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": _vm.displayRequireSign('email') + _vm.displayTextStaff('email', 'Email')
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "readonly": !_vm.isEdit
    },
    model: {
      value: _vm.staff.email,
      callback: function callback($$v) {
        _vm.$set(_vm.staff, "email", $$v);
      },
      expression: "staff.email"
    }
  })], 1) : _vm._e(), _vm.hiddenField('mobile_phone') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": _vm.displayRequireSign('mobile_phone') + _vm.displayTextStaff('mobile', '手機')
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "readonly": !_vm.isEdit
    },
    model: {
      value: _vm.staff.mobile_phone,
      callback: function callback($$v) {
        _vm.$set(_vm.staff, "mobile_phone", $$v);
      },
      expression: "staff.mobile_phone"
    }
  })], 1) : _vm._e(), _vm.hiddenField('job_level') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": _vm.displayRequireSign('job_level') + _vm.displayTextStaff('staff_job_level', '職稱')
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "readonly": !_vm.isEdit
    },
    model: {
      value: _vm.staff.job_level,
      callback: function callback($$v) {
        _vm.$set(_vm.staff, "job_level", $$v);
      },
      expression: "staff.job_level"
    }
  })], 1) : _vm._e(), _vm.hiddenField('service_unit') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": _vm.displayRequireSign('service_unit') + _vm.displayTextStaff('staff_service_unit', '服務單位')
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "readonly": !_vm.isEdit
    },
    model: {
      value: _vm.staff.service_unit,
      callback: function callback($$v) {
        _vm.$set(_vm.staff, "service_unit", $$v);
      },
      expression: "staff.service_unit"
    }
  })], 1) : _vm._e(), _vm.hiddenField('dept_name') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": _vm.displayRequireSign('dept_name') + _vm.displayTextStaff('staff_dept', '部門')
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "readonly": !_vm.isEdit
    },
    model: {
      value: _vm.staff.dept_name,
      callback: function callback($$v) {
        _vm.$set(_vm.staff, "dept_name", $$v);
      },
      expression: "staff.dept_name"
    }
  })], 1) : _vm._e(), _vm.hiddenField('description') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": _vm.displayRequireSign('description') + _vm.displayTextStaff('staff_description', '描述')
    }
  }, [_c('b-form-textarea', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.v$.staff.description.$error ? false : null,
      "readonly": !_vm.isEdit,
      "row": "3"
    },
    model: {
      value: _vm.staff.description,
      callback: function callback($$v) {
        _vm.$set(_vm.staff, "description", $$v);
      },
      expression: "staff.description"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.staff.description.$error
    }
  }, [_vm._v(" " + _vm._s(_vm.displayTextStaff("staff_is_required", "此欄位為必填")) + " ")])], 1) : _vm._e(), _vm.hiddenField('office_phone_area') || _vm.hiddenField('office_phone') || _vm.hiddenField('office_phone_ext') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": _vm.displayRequireSign('office_phone') + _vm.displayTextStaff('staff_phone', '市話')
    }
  }, [_c('div', {
    staticClass: "d-flex w-100 city-selector-set-has-value"
  }, [_c('b-input-group', {
    staticClass: "col-3 px-0",
    attrs: {
      "prepend": "(",
      "append": ")"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mb-sm-0",
    attrs: {
      "type": "text",
      "readonly": !_vm.isEdit,
      "placeholder": "區碼"
    },
    model: {
      value: _vm.staff.office_phone_area,
      callback: function callback($$v) {
        _vm.$set(_vm.staff, "office_phone_area", $$v);
      },
      expression: "staff.office_phone_area"
    }
  })], 1), _c('b-input-group', {
    staticClass: "col-8 px-0",
    attrs: {
      "append": "#"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mb-sm-0",
    attrs: {
      "type": "text",
      "readonly": !_vm.isEdit,
      "placeholder": "市話"
    },
    model: {
      value: _vm.staff.office_phone,
      callback: function callback($$v) {
        _vm.$set(_vm.staff, "office_phone", $$v);
      },
      expression: "staff.office_phone"
    }
  })], 1), _c('b-form-input', {
    staticClass: "mb-2 mb-sm-0 col-1",
    attrs: {
      "type": "text",
      "readonly": !_vm.isEdit,
      "placeholder": "分機"
    },
    model: {
      value: _vm.staff.office_phone_ext,
      callback: function callback($$v) {
        _vm.$set(_vm.staff, "office_phone_ext", $$v);
      },
      expression: "staff.office_phone_ext"
    }
  })], 1), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.staff.office_phone_area.$error && !_vm.v$.staff.office_phone.$error && !_vm.v$.staff.office_phone_ext.$error
    }
  }, [_vm._v(" 此欄位為必須為數字 ")])], 1) : _vm._e(), _vm.hiddenField('line_contact_url') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "Line 連結網址"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "readonly": !_vm.isEdit
    },
    model: {
      value: _vm.staff.line_contact_url,
      callback: function callback($$v) {
        _vm.$set(_vm.staff, "line_contact_url", $$v);
      },
      expression: "staff.line_contact_url"
    }
  })], 1) : _vm._e()], 1)]), _c('div', {
    staticClass: "d-flex justify-content-center",
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("返回 ")]), _vm.isEdit ? _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("儲存")]) : _vm._e()], 1)])], 1)], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }